import React from 'react'
import Helmet from 'react-helmet'

const SEO = ({ title = '', keywords = '', description = '', lang = 'zh-Hans' }) => (
  <Helmet title={title} htmlAttributes={{ lang: lang }}>
    <meta name='keywords' content={keywords} />
    <meta name='description' content={description} />
  </Helmet>
)
export default SEO
